<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <AppForm label="抽出条件" />
      </v-flex>
      <v-flex offset-xs1 xs2>
        <v-select
          v-model="orderDescription.extractionCondition"
          :items="extractionConditions"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs8 offset-xs1 pl-4>
        <div
          ref="condition"
          v-if="orderDescription.extractionCondition"
          :is="displayComponent"
          :menuSetting="menuSetting"
        />
      </v-flex>
      <v-flex xs12 mt-3>
        <AppForm label="対象地域" />
      </v-flex>
      <v-flex xs12 offset-xs1>
        <AppAreaSelectorWithSplitGroupCheckbox :form="form" />
      </v-flex>
      <v-flex xs12>
        <AppForm label="備考" />
      </v-flex>
      <v-flex xs10 mt-1 offset-xs1>
        <v-textarea v-model="orderDescription.memo" outline />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CarType from './CampaignModalPageAutomobileCarType'
import DomesticImportedCarClassification from './CampaignModalPageAutomobileDomesticImportedCarClassification'
import BrandOrCarName from './CampaignModalPageAutomobileBrandOrCarName'
import FirstRegistrationYearMonth from './CampaignModalPageAutomobileFirstRegistrationYearMonth'
import VehicleInspectionExpiration from './CampaignModalPageAutomobileVehicleInspectionExpiration'
import Mileage from './CampaignModalPageAutomobileMileage'

export default {
  name: 'CampaignModalPageAutomobile',
  /* eslint vue/no-unused-components: 0 */
  components: {
    CarType,
    DomesticImportedCarClassification,
    BrandOrCarName,
    FirstRegistrationYearMonth,
    VehicleInspectionExpiration,
    Mileage,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
    orderDescription() {
      return this.menuSetting.orderDescription
    },
    extractionConditions() {
      return [
        {
          text: '選択してください',
          value: '',
        },
        {
          text: '登録車種',
          value: 'car_type',
          component: 'CarType',
        },
        {
          text: '国産車/輸入車',
          value: 'domestic_imported_car_classification',
          component: 'DomesticImportedCarClassification',
        },
        {
          text: 'ブランド・車名',
          value: 'brand_or_car_name',
          component: 'BrandOrCarName',
        },
        {
          text: '初度登録年月',
          value: 'first_registration_year_month',
          component: 'FirstRegistrationYearMonth',
        },
        {
          text: '車検満了年月',
          value: 'vehicle_inspection_expiration',
          component: 'VehicleInspectionExpiration',
        },
        {
          text: '走行距離',
          value: 'mileage',
          component: 'Mileage',
        },
      ]
    },
    displayComponent() {
      const target = this.extractionConditions.find(
        extractionCondition =>
          this.orderDescription.extractionCondition ===
          extractionCondition.value,
      )
      if (target) {
        return target.component
      } else {
        return null
      }
    },
    errorMessage() {
      const errorMessages = []
      if (this.orderDescription.extractionCondition === '') {
        errorMessages.push('抽出条件を指定してください')
      } else if (!this.$refs.condition.validate()) {
        errorMessages.push('抽出条件の年月を正しく設定してください')
      }
      if (
        this.orderDescription.area.isEmpty(
          this.orderDescription.administrativeDistrictType,
        )
      ) {
        errorMessages.push('対象地域を指定してください')
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
  },
}
</script>

<style scoped>
.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
